import ListWalletTransactions from "../../../../components/@transactions/wallet/ListWalletTransactions";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function WalletTransactionsPage() {

    let routeType = routeTypes.admin

    return (
        
        <ListWalletTransactions
            routeType={routeType}
        />
    )
}       